import AtlasMetadataClient from '@reuters-graphics/graphics-atlas-client';
import CountryLink from 'Components/common/CountryLink';
import React from 'react';
import SmartText from '@reuters-graphics/react-smart-text';

const atlas = new AtlasMetadataClient();

const IMG = '//graphics.thomsonreuters.com/data/2020/coronavirus/global-tracker/countries';

const Headline = ({ smartText }) => {
  const { source, context } = smartText;
  const country = atlas.getCountry(context.country);
  const imageSrc = `${IMG}/${country.slug}/charts/${context.metric}.svg`;
  return (
    <div>
      <figure>
        <img src={imageSrc} key={country.slug} />
      </figure>
      <SmartText
        source={source}
        context={{
          ...context,
          country: country ? <CountryLink country={country.isoAlpha2} key={country.isoAlpha2} /> : null,
        }}
        wrap
      />
    </div>
  );
};

export default Headline;
